import React from "react";

const Toggle = ({ checked, onChange, color }) => {
  const containerStyle = {
    width: "44px",
    height: "24px",
    backgroundColor: checked ? color : "#E2E8F0",
    borderRadius: "99px",
    position: "relative",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  };

  const knobStyle = {
    width: "18px",
    height: "18px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    position: "absolute",
    top: "3px",
    left: "3px",
    transform: checked ? "translateX(20px)" : "translateX(0)",
    transition: "transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  };

  return (
    <div onClick={onChange} style={containerStyle}>
      <div style={knobStyle} />
    </div>
  );
};

export default Toggle;
